/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import InputContainer from './InputContainer';
import { useEffect } from 'react';

const TextInputWithInlineLabel = ({
    value,
    onChange,
    onBlur,
    onFocus,
    type,
    placeholder,
    autoFocus,
    required,
    opts,
    className,
    inputClassName,
    prefix,
    suffix,
    label,
    id,
    ...inputProps
}) => {
    return (
        <InputContainer label={label} id={id} className={className}>
            <div className={`relative rounded-lg`}>
                {!!prefix && (
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <span className="text-gray-500 sm:text-sm">
                            {prefix}
                        </span>
                    </div>
                )}

                <input
                    type={type || 'text'}
                    value={value}
                    placeholder={placeholder}
                    onChange={e => onChange(e.target.value)}
                    className={`w-full ${inputClassName}`}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    autoFocus={autoFocus}
                    required={required}
                    {...opts}
                    {...inputProps}
                />

                {!!suffix && (
                    <div className="absolute inset-y-0 right-0 flex items-center">
                        <span className="text-gray-500 sm:text-sm mr-2">
                            {suffix}
                        </span>
                    </div>
                )}
            </div>
        </InputContainer>
    );
};

export default TextInputWithInlineLabel;
